module.exports = __webpack_public_path__ + "static/media/de.a2e72ce8.svg";